const TemoignageReducer = (state = [], action) => {
      return state;
}

export default TemoignageReducer;
